/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { XHR } from './XHR'
import { AuthenticationProvider, NoAuthenticationProvider } from '../../icc-x-api/auth/AuthenticationProvider'
import { iccRestApiPath } from './IccRestApiPath'

export class IccBeresultexportApi {
  host: string
  headers: Array<XHR.Header>
  authenticationProvider: AuthenticationProvider
  fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>

  constructor(
    host: string,
    headers: any,
    authenticationProvider?: AuthenticationProvider,
    fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>
  ) {
    this.host = iccRestApiPath(host)
    this.headers = Object.keys(headers).map((k) => new XHR.Header(k, headers[k]))
    this.authenticationProvider = !!authenticationProvider ? authenticationProvider : new NoAuthenticationProvider()
    this.fetchImpl = fetchImpl
  }

  setHeaders(h: Array<XHR.Header>) {
    this.headers = h
  }

  handleError(e: XHR.XHRError): never {
    throw e
  }

  /**
   *
   * @summary Export data
   * @param body
   * @param fromHcpId
   * @param toHcpId
   * @param patId
   * @param date
   * @param ref
   */
  exportHealthOne(fromHcpId: string, toHcpId: string, patId: string, date: number, ref: string, body?: ArrayBuffer): Promise<ArrayBuffer> {
    let _body = null
    _body = body

    const _url =
      this.host +
      `/be_result_export/hl1/${encodeURIComponent(String(fromHcpId))}/${encodeURIComponent(String(toHcpId))}/${encodeURIComponent(
        String(patId)
      )}/${encodeURIComponent(String(date))}/${encodeURIComponent(String(ref))}` +
      '?ts=' +
      new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/octet-stream'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => doc.body)
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Export data
   * @param body
   * @param fromHcpId
   * @param toHcpId
   * @param patId
   * @param date
   * @param ref
   * @param mimeType
   */
  exportKmehrReport(
    fromHcpId: string,
    toHcpId: string,
    patId: string,
    date: number,
    ref: string,
    mimeType?: boolean,
    body?: ArrayBuffer
  ): Promise<ArrayBuffer> {
    let _body = null
    _body = body

    const _url =
      this.host +
      `/be_result_export/kmehrreport/${encodeURIComponent(String(fromHcpId))}/${encodeURIComponent(String(toHcpId))}/${encodeURIComponent(
        String(patId)
      )}/${encodeURIComponent(String(date))}/${encodeURIComponent(String(ref))}` +
      '?ts=' +
      new Date().getTime() +
      (mimeType ? '&mimeType=' + encodeURIComponent(String(mimeType)) : '')
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/octet-stream'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => doc.body)
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Export data
   * @param body
   * @param fromHcpId
   * @param toHcpId
   * @param patId
   * @param date
   * @param ref
   */
  exportMedidoc(fromHcpId: string, toHcpId: string, patId: string, date: number, ref: string, body?: ArrayBuffer): Promise<ArrayBuffer> {
    let _body = null
    _body = body

    const _url =
      this.host +
      `/be_result_export/medidoc/${encodeURIComponent(String(fromHcpId))}/${encodeURIComponent(String(toHcpId))}/${encodeURIComponent(
        String(patId)
      )}/${encodeURIComponent(String(date))}/${encodeURIComponent(String(ref))}` +
      '?ts=' +
      new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/octet-stream'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => doc.body)
      .catch((err) => this.handleError(err))
  }
}
